var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex upper-case",class:{
		'grade-chip-empty': _vm.empty,
		'grade-chip': !_vm.empty,
	},on:{"click":($event) => _vm.$emit('click', $event)}},[_c('div',{staticClass:"my-auto",class:{ [_vm.EmptyPadding]: _vm.empty }},[(_vm.empty)?[_vm._v(" Add Score ")]:[_c('div',[_c('ProgressBar',{attrs:{"progress":_vm.progress,"inset":"","color":_vm.Color}}),_c('div',{staticClass:"baColorPrimaryText--text"},[_vm._t("default")],2)],1)]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }